<template>
  <el-dialog
    :model-value="localValue"
    @update:model-value="onDialogUpdate"
    append-to-body
    top="2vh"
    class="ChildrenWhatsAppModal"
    @close="close"
  >
    <div class="form-wrapper">
      <div class="pb-8">
        <div class="form-row">
          <div class="form-item">
            <div class="form-label">
              Select Template:
            </div>
            <el-select
              v-model="whatsappTemplate"
              filterable
              value-key="template_id"
            >
              <el-option
                v-for="(template, i) in whatsappTemplates"
                :key="`t-wa-${i}`"
                :value="template"
                :label="template.name + ` ID:${template.ns}`"
              />
            </el-select>
          </div>
          <div v-if="!isStaff" class="form-item">
            <div class="form-label">
              Recipient:
            </div>
            <el-checkbox-group v-model="whatsappRecipients">
              <el-checkbox :label="CONTACT_TYPE.MOTHER" border>Mother</el-checkbox>
              <el-checkbox :label="CONTACT_TYPE.FATHER" border>Father</el-checkbox>
              <el-checkbox :label="CONTACT_TYPE.CHILD" border>Child</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>

      <div class="flex px-3 pb-6 whatsapp-actions">
        <el-button
          :disabled="(!isStaff && !whatsappRecipients.length) || !whatsappTemplate"
          :loading="loading"
          @click="onSend"
          type="primary"
        >
          <i class="vc-icon-skip-arrow mr-2 icon-lg"></i>
          Send WhatsApp
        </el-button>
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer pb-3 px-5">
        <el-button @click="close">
          <i class="vc-icon-cancel icon-base mr-2"></i>
          Cancel
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import Messages from "controllers/Messages";
import Children from "controllers/Children";
import Staff from "controllers/Staff";
import CONTACT_TYPE from "@/enum/contactType";

export default {
  name: "ChildrenWhatsAppModal",
  computed: {
    CONTACT_TYPE() {
      return CONTACT_TYPE
    }
  },
  props: {
    modelValue: Boolean,
    dataFields: Array,
    isStaff: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      loading: false,
      localValue: false,
      whatsappTemplate: null,
      whatsappRecipients: [],
      whatsappTemplates: [],
      localDataFields: []
    }
  },
  watch: {
    modelValue(val) {
      this.localValue = val
      if (val) {
        this.localDataFields = [...this.dataFields]
        this.loadWhatsAppTemplates()
      }
    }
  },
  methods: {
    onDialogUpdate(val) {
      this.localValue = val
      this.$emit("update:modelValue", val)
    },
    async loadWhatsAppTemplates() {
      const flows = await Messages.getWhatsAppFlows()
      this.whatsappTemplates = flows.map(f => ({
        template_id: f.ns,
        ns: f.ns,
        name: f.name
      }))
    },
    resetForm() {
      this.whatsappTemplate = null
      this.whatsappRecipients = []
    },
    close() {
      this.resetForm()
      this.onDialogUpdate(false)
    },
    async onSend() {
      try {
        this.loading = true
        if (this.isStaff) {
          const entityIds = this.dataFields.map(d => d.id).filter(Boolean)
          const payload = {
            StaffID: entityIds,
            ns: this.whatsappTemplate.ns,
            ContactType: [CONTACT_TYPE.STAFF]
          }
          await Staff.SendWhatsApp(payload)
        } else {
          const payload = {
            ChildrenID: this.localDataFields.map(d => d.id),
            ns: this.whatsappTemplate.ns,
            ContactType: this.whatsappRecipients
          }
          await Children.BulkSendWhatsApp(payload)
        }
        this.$message.success('WhatsApp messages sent successfully')
        this.resetForm()
        this.onDialogUpdate(false)

      } catch (e) {
        console.error(e)
        this.$message.error('Error while sending WhatsApp')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
